import React, { useState } from "react";
import {
  FaCheckCircle as CheckCircle,
  FaCalendarAlt as Calendar,
  FaShare as Share,
  FaHome as Home,
  FaWhatsapp as Whatsapp,
  FaTwitter as Twitter,
  FaFacebook as Facebook,
  FaCheck as Check,
  FaEnvelopeOpen as EnvelopeOpen,
  FaTicketAlt as Ticket,
} from "react-icons/fa";
import "./success-failure.css";

export default function SuccessPage({
  registrationData,
  onBackToHome,
  completeEventData,
}) {
  console.log(completeEventData,"completeventData")
  const [showShareOptions, setShowShareOptions] = useState(false);
  console.log(registrationData, "registrationData");
  const defaultDatas = completeEventData.event_configuration.online_thank_you;
  // Use passed data or fallback to sample data
  const data = registrationData;

  const handleAddToCalendar = () => {
    const startDate = new Date("2025-08-28T09:00:00");
    const endDate = new Date("2025-08-31T17:00:00");

    const calendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      data.eventName
    )}&dates=${startDate.toISOString().replace(/[-:]/g, "").split(".")[0]}Z/${
      endDate.toISOString().replace(/[-:]/g, "").split(".")[0]
    }Z&details=${encodeURIComponent(
      "Medical Conference Registration Confirmed"
    )}&location=${encodeURIComponent(data.venue)}`;

    window.open(calendarUrl, "_blank");
  };

  const handleShare = (platform) => {
    const shareText = `Successfully registered for ${data.eventName}! Join me at this medical conference from ${data.eventDate} in ${data.venue}. #AMASICON2025 #MedicalConference`;
    const shareUrl = window.location.origin;

    switch (platform) {
      case "whatsapp":
        window.open(
          `https://wa.me/?text=${encodeURIComponent(
            shareText + " " + shareUrl
          )}`
        );
        break;
      case "twitter":
        window.open(
          `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            shareText
          )}&url=${encodeURIComponent(shareUrl)}`
        );
        break;
      case "facebook":
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            shareUrl
          )}&quote=${encodeURIComponent(shareText)}`
        );
        break;
    }
    setShowShareOptions(false);
  };

  return (
    <section className="success_failer_common">
      <div className="success-container">
        {/* Background with decorative elements */}
        <div className="success-background">
          <div className="bg-decorations">
            <div className="decoration-circle-1"></div>
            <div className="decoration-circle-2"></div>
            <div className="decoration-circle-3"></div>
            <div className="floating-shape-1"></div>
            <div className="floating-shape-2"></div>
            <div className="floating-shape-3"></div>
            <div className="triangle-1"></div>
            <div className="triangle-2"></div>
            <div className="diamond-1"></div>
            <div className="diamond-2"></div>
            <div className="particle-1"></div>
            <div className="particle-2"></div>
            <div className="particle-3"></div>
            <div className="particle-4"></div>
            <div className="particle-5"></div>
            <div className="gradient-orb-1"></div>
            <div className="gradient-orb-2"></div>
            <div className="gradient-orb-3"></div>
            <div className="polygon-1"></div>
            <div className="polygon-2"></div>
            <div className="spiral-1"></div>
            <div className="spiral-2"></div>
            <div className="plus-1"></div>
            <div className="plus-2"></div>
          </div>
          <div className="stripe-pattern"></div>
        </div>

        {/* Success Content */}
        <div className="success-content">
          <div className="success-card">
            {/* Header */}
            <div className="success-header">
              <div className="event-header">
                <h1 className="event-title">{data.eventName}</h1>
                {/* <p className="event-subtitle">
                {data.eventDate} | {data.venue}
              </p> */}
              </div>
            </div>

            {/* Success Message */}
            <div className="success-message">
              <div className="success-icon">
                <CheckCircle />
              </div>
              <h2 className="success-title">Registration Confirmed!</h2>
              <p className="success-subtitle">
                {defaultDatas ||
                  ` Congratulations! Your registration for ${data.eventName} has been
                successfully processed. We've sent a detailed confirmation
                receipt to your email address`}
              </p>{" "}
              <div className="success-badges">
                <span className="success-badge">
                  {/* <Ticket className="badge-icon" /> */}
                  Tickets Generated
                </span>
                {data.paymentDetails.amountPaid >= 1 && (
                  <span className="success-badge">
                    {/* <Check className="badge-icon" /> */}
                    Payment Verified
                  </span>
                )}
                <span className="success-badge">
                  <EnvelopeOpen className="badge-icon" />
                  Email Sent
                </span>
              </div>
            </div>

            {/* Event Details */}
            {/* <div className="details-section">
            <h3 className="section-title">Event Details</h3>
            <div className="event-info">
              <h4 className="event-name">{data.eventName}</h4>
              <div className="event-datetime">
                <div className="datetime-info">
                  <Calendar className="datetime-icon" />
                  <div>
                    <div className="datetime-label">Event Date & Time</div>
                    <div className="datetime-value">
                      {data.eventDate}, {data.eventTime}
                    </div>
                  </div>
                </div>
                <button onClick={handleAddToCalendar} className="add-calendar-btn">
                  Add to Calendar
                </button>
              </div>
            </div>
          </div> */}

            {/* Attendees */}
            {data.attendees && data.attendees.length > 0 && (
              <div className="details-section">
                <h3 className="section-title">
                  Attendees ({data.attendees.length})
                </h3>
                <div className="attendees-list">
                  {data.attendees.map((attendee, index) => (
                    <div key={attendee.id || index} className="attendee-item">
                      <div className="attendee-number">{index + 1}.</div>
                      <div className="attendee-details">
                        <div className="attendee-name">
                          {attendee.fullName ||
                            attendee.first_name + " " + attendee.last_name}
                        </div>
                        <div className="attendee-email">{attendee.email}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Guests */}
            {data.guests && data.guests.length > 0 && (
              <div className="details-section">
                <h3 className="section-title">Guests</h3>
                <div className="guests-list">
                  {data.guests.map((guest, index) => (
                    <div key={guest.id || index} className="guest-item">
                      <div className="guest-number">
                        {(data.attendees?.length || 0) + index + 1}.
                      </div>
                      <div className="guest-details">
                        <div className="guest-name">
                          {guest.guestName ||
                            guest.first_name + " " + guest.last_name}
                        </div>
                        <div className="guest-email">{guest.email}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Payment Details */}
            <div className="details-section">
              <h3 className="section-title">Payment Details</h3>
              <div className="payment-grid">
                <div className="payment-left">
                  <div className="payment-item">
                    <div className="payment-label">Payment Date & Time</div>
                    <div className="payment-value">
                      {data.paymentDetails.paymentDate},{" "}
                      {data.paymentDetails.paymentTime}
                    </div>
                  </div>
                  <div className="payment-item">
                    <div className="payment-label">Amount Paid</div>
                    <div className="payment-value amount">
                      {data.paymentDetails.amountPaid}
                    </div>
                  </div>
                </div>
                <div className="payment-right">
                  {/* <div className="payment-item">
                  <div className="payment-label">Buyer Name</div>
                  <div className="payment-value">{data.paymentDetails.buyerName}</div>
                </div> */}
                  <div className="payment-item">
                    <div className="payment-label">Payment Method</div>
                    <div className="payment-value">
                      {data.paymentDetails.paymentMethod}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Back to Home */}
            <div className="back-home">
              <button
                className="btn btn-primary btn-large"
                onClick={onBackToHome || (() => (window.location.href = "/"))}
              >
                <Home className="btn-icon" />
                Back to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
